import type { Image, ImageVariants } from '../../src/models/IImage';

import PlaceholderImage from 'assets/images/placeholder.png';

const getImageVariantByFieldname = (image: Image, fieldname: string, altVariant?: string) => {
  try {
    return image.variants[fieldname] || image.variants[altVariant];
  } catch (err) {
    console.error(err);
  }

  return null;
};

// TODO: Позволить указывать fieldname как массив со значениями в порядке приоритета
const getImageVariantProps = (variants: ImageVariants, fieldname: string) => {
  return {
    src: variants
      ? variants[fieldname + '_webp']?.url || variants[fieldname]?.url || variants.original?.url
      : PlaceholderImage,
    width: variants
      ? variants[fieldname + '_webp']?.meta.width || variants[fieldname]?.meta.width || variants.original?.meta.width
      : undefined,
    height: variants
      ? variants[fieldname + '_webp']?.meta.height || variants[fieldname]?.meta.height || variants.original?.meta.height
      : undefined,
    unoptimized: true,
  };
};

export { getImageVariantByFieldname, getImageVariantProps };
